module.exports = __webpack_public_path__ + "static/media/adaptive-icon.ba537885.png";